export default "__VITE_ASSET__whgfi_py__"